<script>
import ActionItem from './ActionItem'

export default {
  name: 'ActionGroup',
  props: {
    hideOnEmpty: {
      type: Boolean,
      default: false
    },
    divider: {
      type: Boolean,
      default: true
    }
  },
  render (h) {
    const defaultSlot = this.$slots.default || []
    const emptySlot = this.$slots.empty

    // 过滤出 ActionItem vnode（跳过空白文本节点）
    const actionNodes = defaultSlot.filter(vnode => {
      if (!vnode.componentOptions) return false
      const ctor = vnode.componentOptions.Ctor
      return ctor && (ctor.options.name === 'ActionItem' || (ctor.extendOptions && ctor.extendOptions.name === 'ActionItem'))
    })

    const hasItems = actionNodes.length > 0

    if (this.hideOnEmpty && !hasItems) {
      return null
    }

    const leftNodes = actionNodes.filter(vnode => {
      const pos = vnode.componentOptions.propsData && vnode.componentOptions.propsData.position
      return pos !== 'right'
    })
    const rightNodes = actionNodes.filter(vnode => {
      const pos = vnode.componentOptions.propsData && vnode.componentOptions.propsData.position
      return pos === 'right'
    })

    const insertDividers = (nodes) => {
      if (!this.divider || nodes.length <= 1) return nodes
      const result = []
      nodes.forEach((node, i) => {
        if (i > 0) {
          result.push(h('el-divider', { attrs: { direction: 'vertical' }, key: 'divider-' + i }))
        }
        result.push(node)
      })
      return result
    }

    const leftContent = hasItems ? insertDividers(leftNodes) : (emptySlot || [])
    const rightContent = insertDividers(rightNodes)

    const children = [
      h('div', { class: 'action-group__left' }, leftContent)
    ]
    if (rightContent.length > 0) {
      children.push(h('div', { class: 'action-group__right' }, rightContent))
    }

    return h('div', { class: 'action-group' }, children)
  }
}
</script>

<style lang="scss" scoped>
.action-group {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  &__left,
  &__right {
    display: flex;
    align-items: center;

    .el-divider--vertical {
      margin: 0 8px;
    }
  }

  &__left {
    flex-wrap: wrap;
  }

  &__right {
    margin-left: 15px;
  }
}
</style>
